import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../../components/baseUrl";

export const api = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: `${API_BASE_URL}/api` }),
  tagTypes: [
    "users",
    "category",
    "sub_category",
    "bankInfo",
    "bankdeposit",
    "damageproduct",
    "dealers",
    "suppliers",
    "dueHistory",
    "openingbalc",
    "sales_master",
    "pay-dues",
    "products",
    "purchases",
    "sales",
    "orders",
    "warehouses",
    "salesRate",
    "ledger",
    "all_jv",
    "return-two",
    "return",
    "unit",
    "expense",
    "challan_master",
    "quotation-main",
    "quotation",
    "pro-service",
    "all_model",
    "subjects",
    "website",
  ],
  endpoints: (builder) => ({}),
});
